import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";

Backdraft.app("Shared/ExpressionBuilder", function(app) {
  app.model("AdwordsDataTerminal", "StringCompareTerminal", {
    defaults: {
      relop: "=",
      value: "",
      adwords_data_name: ""
    },

    initialize: function() {
      this.on('change:relop', function() {
        if (this.get('relop') === "present") {
          this._triggerValidations();
        }
      });

      this.on('change:adwords_data_name', function() {
        if (this.previousAttributes().adwords_data_name === "" && this.get('adwords_data_name') !== "") {
          this._triggerValidations();
        }
      });
    },

    type: function() {
      return 'AdwordsData';
    },

    validate: function() {
      var errors = [];

      if (this._shouldAddValueErrors()) { errors.push(this._valueError()); }
      if (this.get("adwords_data_name") === "" || this.get("adwords_data_name") === undefined) {
        errors.push("expected adwords_data['key'] = 'value', key cannot be empty");
      }

      if (!_.isEmpty(errors)) { return errors; }
    },

    _textPrefix: function() {
      return "adwords_data" + "[" + this.get('adwords_data_name') + "]";
    }
  });
});
